import React, { useState, useEffect, useRef } from 'react';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';

const projects = [
  {
    name: 'Taimi',
    image: '/pictures/small_taimi_large_81784911fd.jpg',
    category: 'Web-app development',
    description: 'Taimi provides a secure platform for project managers to make sure that their data is safe and confidential. It has not only revolutionized the way people manage their work but also the way they protect their digital assets.',
    href: '#',
  },
  {
    name: 'Swarm',
    image: '/pictures/small_swarm_large_ff6f238dff.jpg',
    category: 'Web-app development',
    description: 'Swarm is a powerful, self-organizing, perimeter-less solution for zero-trust access using swarm intelligence. The unique architecture of the swarm prevents potential sources of danger from the outside.',
    href: '#',
  },
  {
    name: 'DAVIT',
    image: '/pictures/small_davit_large_75f4b80366.jpg',
    category: 'Web-app development',
    description: 'Davit is an automation service of Electric power that refers to functional materials in which manual labor is lessened to deliver the best solutions for our clients.',
    href: '#',
  },
  {
    name: 'dxodav',
    image: '/pictures/small_dxodav_large_2964338995.jpg',
    category: 'Web-app development',
    description: 'dxodav is a top-of-the-line SaaS-based user identity and access management system that provides a secure and convenient solution to manage user identities and access control.',
    href: '#',
  },
  {
    name: 'Ufyle',
    image: '/pictures/small_ufyle_large_ca1410599d.jpg',
    category: 'Web-app development',
    description: 'Ufyle supports multiple file transfer protocols and SFTP client, enabling users to transfer files between local and remote computers.',
    href: '#',
  },
  {
    name: 'Test Engine',
    image: '/pictures/small_test_engine_large_5efe6bac6c.jpg',
    category: 'Web-app development',
    description: 'Test Engine is a robust and efficient website designed to help HR Management evaluate their IT candidates by offering multiple-choice questions in a limited time.',
    href: '#',
  },
  {
    name: 'Solaris',
    image: '/pictures/small_solaris_large_b0f8543e87.jpg',
    category: 'Web-app development',
    description: 'We use cutting-edge technology to predict and analyze market trends, helping agriculture agencies make informed decisions. Discover how Solaris can help your business thrive today!',
    href: '#',
  },
  {
    name: 'Orion',
    image: '/pictures/small_orion_large_11c0beb297.jpg',
    category: 'Web-app development',
    description: 'Orion is a suite of solutions designed to enhance the guest experience and drive booking management for hoteliers. Maximize your hotel\'s potential with Orion!',
    href: '#',
  },
];

const CARDS_PER_VIEW = 3;

export default function Projects() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const maxIndex = Math.max(0, projects.length - CARDS_PER_VIEW);

  const prev = () => {
    if (isAnimating || currentIndex === 0) return;
    setIsAnimating(true);
    setCurrentIndex(i => i - 1);
    setTimeout(() => setIsAnimating(false), 400);
  };

  const next = () => {
    if (isAnimating || currentIndex >= maxIndex) return;
    setIsAnimating(true);
    setCurrentIndex(i => i + 1);
    setTimeout(() => setIsAnimating(false), 400);
  };

  return (
    <section style={{ padding: '100px 0', background: '#F9FAFB' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '48px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
              <div style={{ width: '24px', height: '3px', backgroundColor: '#0099CC', borderRadius: '2px' }}></div>
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#0099CC', textTransform: 'uppercase', letterSpacing: '1px' }}>
                Portfolio
              </span>
            </div>
            <h2 style={{ fontSize: 'clamp(28px, 3vw, 40px)', fontWeight: '700', color: '#111827', marginBottom: '12px', letterSpacing: '-0.5px' }}>
              Our Projects
            </h2>
            <p style={{ fontSize: '17px', color: '#6B7280', lineHeight: 1.7 }}>
              Learn more about our utilization of cyber security solutions.
            </p>
          </div>
          <a
            href="#"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              color: '#0099CC',
              textDecoration: 'none',
              fontSize: '15px',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              transition: 'gap 0.2s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.gap = '10px'}
            onMouseLeave={e => e.currentTarget.style.gap = '6px'}
          >
            View all <ArrowRight size={16} />
          </a>
        </div>

        {/* Carousel */}
        <div style={{ position: 'relative', overflow: 'hidden' }}>
          <div
            style={{
              display: 'flex',
              gap: '24px',
              transition: 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
              transform: `translateX(calc(-${currentIndex} * (100% / ${CARDS_PER_VIEW} + 8px)))`,
            }}
          >
            {projects.map((project, idx) => (
              <div
                key={idx}
                className="project-card"
                style={{
                  flex: `0 0 calc((100% - ${(CARDS_PER_VIEW - 1) * 24}px) / ${CARDS_PER_VIEW})`,
                  background: 'white',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  border: '1px solid #E5E7EB',
                }}
              >
                <div style={{ position: 'relative', lineHeight: 0 }}>
                  <img
                    src={project.image}
                    alt={project.name}
                    style={{ width: '100%', height: '220px', objectFit: 'cover', display: 'block' }}
                    onError={e => {
                      e.target.src = `https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=400&q=70`;
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    top: '16px',
                    left: '16px',
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    color: 'white',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: '500',
                    backdropFilter: 'blur(4px)',
                  }}>
                    {project.category}
                  </div>
                </div>
                <div style={{ padding: '24px' }}>
                  <h3 style={{ fontSize: '20px', fontWeight: '700', color: '#111827', marginBottom: '12px' }}>
                    {project.name}
                  </h3>
                  <p style={{ fontSize: '14px', color: '#6B7280', lineHeight: 1.7, marginBottom: '20px' }}>
                    {project.description}
                  </p>
                  <a
                    href={project.href}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      color: '#0099CC',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: '600',
                      transition: 'gap 0.2s ease',
                    }}
                    onMouseEnter={e => e.currentTarget.style.gap = '10px'}
                    onMouseLeave={e => e.currentTarget.style.gap = '6px'}
                  >
                    Learn more <ArrowRight size={16} />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Controls */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', marginTop: '40px' }}>
          <button
            onClick={prev}
            disabled={currentIndex === 0}
            style={{
              width: '48px', height: '48px',
              borderRadius: '50%',
              border: '2px solid',
              borderColor: currentIndex === 0 ? '#E5E7EB' : '#111827',
              background: 'white',
              cursor: currentIndex === 0 ? 'default' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s ease, border-color 0.2s ease',
              opacity: currentIndex === 0 ? 0.4 : 1,
            }}
            onMouseEnter={e => { if (currentIndex > 0) { e.currentTarget.style.backgroundColor = '#111827'; e.currentTarget.querySelector('svg').style.stroke = 'white'; } }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'white'; if (e.currentTarget.querySelector('svg')) e.currentTarget.querySelector('svg').style.stroke = 'currentColor'; }}
          >
            <ChevronLeft size={20} color={currentIndex === 0 ? '#9CA3AF' : '#111827'} />
          </button>

          {/* Dots */}
          <div style={{ display: 'flex', gap: '8px' }}>
            {Array.from({ length: maxIndex + 1 }).map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                style={{
                  width: i === currentIndex ? '24px' : '8px',
                  height: '8px',
                  borderRadius: '4px',
                  border: 'none',
                  cursor: 'pointer',
                  backgroundColor: i === currentIndex ? '#111827' : '#D1D5DB',
                  transition: 'width 0.3s ease, background-color 0.3s ease',
                  padding: 0,
                }}
              />
            ))}
          </div>

          <button
            onClick={next}
            disabled={currentIndex >= maxIndex}
            style={{
              width: '48px', height: '48px',
              borderRadius: '50%',
              border: '2px solid',
              borderColor: currentIndex >= maxIndex ? '#E5E7EB' : '#111827',
              background: 'white',
              cursor: currentIndex >= maxIndex ? 'default' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s ease, border-color 0.2s ease',
              opacity: currentIndex >= maxIndex ? 0.4 : 1,
            }}
            onMouseEnter={e => { if (currentIndex < maxIndex) { e.currentTarget.style.backgroundColor = '#111827'; e.currentTarget.querySelector('svg').style.stroke = 'white'; } }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'white'; if (e.currentTarget.querySelector('svg')) e.currentTarget.querySelector('svg').style.stroke = 'currentColor'; }}
          >
            <ChevronRight size={20} color={currentIndex >= maxIndex ? '#9CA3AF' : '#111827'} />
          </button>
        </div>
      </div>
    </section>
  );
}
